'use client';

import type {TransitionStartFunction} from 'react';
import {useActionState, useTransition} from 'react';

import type {AddToCartActionState, UpdateCartActionState} from '../actions';
import {addToCart, updateCart} from '../actions';

export type CartState = {
	isRefreshing: boolean;
	startRefresh: TransitionStartFunction;
	isAddingToCart: boolean;
	addToCartState: AddToCartActionState;
	addToCartAction: (payload: FormData) => void;
	isUpdatingCart: boolean;
	updateCartState: UpdateCartActionState;
	updateCartAction: (payload: FormData) => void;
};

export function useCart(): CartState {
	const [isRefreshing, startRefresh] = useTransition();

	const [addToCartState, addToCartAction, isAddingToCart] = useActionState(addToCart, {});
	const [updateCartState, updateCartAction, isUpdatingCart] = useActionState(updateCart, {});

	return {
		isRefreshing,
		startRefresh,
		addToCartState,
		addToCartAction,
		isAddingToCart,
		updateCartState,
		updateCartAction,
		isUpdatingCart,
	};
}
